import { leadCardRefreshReducer } from '@app/components/LeadCard/model/leadCardRefreshSlice';
import { leadsLatestRegistryResultReducer } from '@app/pages/Leads/model/latestRegistryResultSlice';
import { accessRightsReducer } from '@app/store/slices/AccessRights/slice';

export const slices = {
  newAccessRights: accessRightsReducer,
  leadsLatestRegistryResult: leadsLatestRegistryResultReducer,
  leadCardRefresh: leadCardRefreshReducer,
};
